import { useAPPstore } from '@/service/stores/cm/cmcm/APP.store'

export const httpHelper = async (axiosPromise, fdata) => {
  // 글로벌 APP 스토어
  const APPstore = useAPPstore()
  try {
    const { data } = await axiosPromise(fdata)
    // this.saveUserSuccess = (await data?.meta?.code) === '0000'
    return data
  } catch (error) {
    // this.errorInfo = '에러가 발생했습니다. #3'
    // console.debug('httpHelper error :', error)
    // console.debug('httpHelper error.message :', error.message)
    // console.debug('httpHelper error.response :', error.response)
    const { response } = error
    APPstore.setNetworkAlertMsg(error.message)
    if (response !== '' && response !== undefined) {
      const { data } = response
      if (data !== '' && data.meta !== undefined) {
        APPstore.setNetworkAlertMsg(data.meta.msg + '')
      }
    }
    APPstore.setShowNetworkAlert(true)
    return Promise.reject(error)
  }
}
